import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '@graphql/admin/fragments';

export const updateScheduledSessionMutation = gql`
  mutation UpdateScheduledSession($id: ID!, $input: UpdateScheduledSessionInput!) {
    updateScheduledSession(id: $id, input: $input) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;